

/********CSTM SLIDER*********/
let currentSlide = 0;
const slides = document.querySelectorAll('#cstmslider input[type="radio"]');
const totalSlides = slides.length;

function autoRotate() {
  // Remove checked state from current radio button
  slides[currentSlide].checked = false;

  // Move to the next slide
  currentSlide = (currentSlide + 1) % totalSlides;

  // Set the next slide to be checked
  slides[currentSlide].checked = true;
}

// Set an interval to rotate every 2 seconds
setInterval(autoRotate, 2000);


/********CSTM SLIDER*********/



/********LANGUAGE POPUP*********/
window.onload = function() {
  // Check if the user has already made a language selection
  const cstmpopup = document.getElementById("cstmpopup");
  const englishBtn = document.getElementById("englishBtn");
  const urduBtn = document.getElementById("urduBtn");
  const closePopup = document.getElementById("closePopup");
  const currentUrl = window.location.href;

  // Check if the popup should be shown (based on localStorage)
  if (!localStorage.getItem('languageSelected')) {
    cstmpopup.style.display = "flex"; // Show the popup if not selected previously
  } else {
    cstmpopup.style.display = "none"; // Hide the popup if language was already selected
  }

  // When the user clicks on English button
  englishBtn.onclick = function() {
    if (currentUrl !== "https://sobyagro.co/") {
      window.location.href = "https://sobyagro.co/";
    } else {
      cstmpopup.style.display = "none"; // Close the popup if already on English page
    }
    // Set the language selected flag in localStorage
    localStorage.setItem('languageSelected', 'english');
  };

  // When the user clicks on Urdu button
  urduBtn.onclick = function() {
    if (currentUrl !== "https://sobyagro.co/ur") {
      window.location.href = "https://sobyagro.co/ur";
    } else {
      cstmpopup.style.display = "none"; // Close the popup if already on Urdu page
    }
    // Set the language selected flag in localStorage
    localStorage.setItem('languageSelected', 'urdu');
  };

  // Close the popup when the user clicks the close button
  closePopup.onclick = function() {
    cstmpopup.style.display = "none";
  };

  // Close the popup if user clicks anywhere outside the popup
  window.onclick = function(event) {
    if (event.target === cstmpopup) {
      cstmpopup.style.display = "none";
    }
  };
};


/********LANGUAGE POPUP*********/


/********STOP ALREADY PLAYED VIDEO*********/
  document.addEventListener('play', function(e) {
    const videos = document.getElementsByTagName('video');
    for (let v of videos) {
      if (v !== e.target) {
        v.pause();
        v.currentTime = 0; // reset to start (optional)
      }
    }
  }, true); // use capture phase so event is caught from any video


/********STOP ALREADY PLAYED VIDEO*********/




/********BOTTOM IMAGE POPUP*********/
  document.addEventListener("DOMContentLoaded", function () {
    const popupLinks = document.querySelectorAll('[data-popup-image]');
    const overlay = document.getElementById("image-popup-overlay");
    const popupImg = document.getElementById("popup-img");
    const closeBtn = document.getElementById("popup-close");

    popupLinks.forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const imgSrc = this.getAttribute("href");
        popupImg.setAttribute("src", imgSrc);
        overlay.style.display = "flex";
      });
    });

    closeBtn.addEventListener("click", function () {
      overlay.style.display = "none";
      popupImg.setAttribute("src", "");
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        overlay.style.display = "none";
        popupImg.setAttribute("src", "");
      }
    });
  }); 
 
/********BOTTOM IMAGE POPUP*********/